export const playColors = {
  primary: '#1CCBD3',
  primaryAlt: '#048186',
  black: '#002C2F',
  grey: '#585858',
  white: '#eaede8',
  highlight: '#fff271',
};
